import { render, staticRenderFns } from "./material-category-distribution-add.vue?vue&type=template&id=7a5d29ff&scoped=true"
import script from "./material-category-distribution-add.vue?vue&type=script&lang=js"
export * from "./material-category-distribution-add.vue?vue&type=script&lang=js"
import style0 from "./material-category-distribution-add.vue?vue&type=style&index=0&id=7a5d29ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5d29ff",
  null
  
)

export default component.exports